import Link from "next/link";
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";

import { useI18n } from "@/i18n/I18nProvider";
import { colors } from "@/utils/const";

const SEPARATOR_SRC =
  "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/arrow.svg";

const HOME_ICON_SRC =
  "https://contact-eg.s3.us-east-2.amazonaws.com/leads/breadcrumb_icon.svg";

const rootSx = { mt: 5 };
const iconSx = { display: "flex", alignItems: "center" };
const currentSx = { color: colors.orange, mt: { xs: 1, md: 0 } };

const BreadcrumbsNav = ({ links, currentText, iconLink = "/", aboveBg }) => {
  const { locale } = useI18n();

  const linkColor = aboveBg ? colors.white : colors.blue;

  return (
    <Box sx={rootSx}>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={
          <img
            src={SEPARATOR_SRC}
            alt=""
            aria-hidden="true"
            width={7}
            height={12}
            style={{ transform: locale === "ar" ? "scaleX(-1)" : "scaleX(1)" }}
          />
        }
      >
        <Box component={Link} href={iconLink} sx={iconSx}>
          <img
            src={HOME_ICON_SRC}
            alt=""
            aria-hidden="true"
            style={{ width: 24, height: 24 }}
          />
        </Box>

        {links.filter(Boolean).map((link) =>
          /*
           * Real anchors rather than onClick handlers: breadcrumbs are a primary
           * internal-linking signal and need to be crawlable and focusable.
           */
          link.noHref ? (
            <Box key={link.label} sx={{ color: linkColor, display: "inline" }}>
              {link.label}
            </Box>
          ) : (
            <Box
              key={link.label}
              component={Link}
              href={link.href}
              sx={{
                color: linkColor,
                display: "inline",
                cursor: "pointer",
                textDecoration: "none",
              }}
            >
              {link.label}
            </Box>
          ),
        )}

        {currentText && <Typography sx={currentSx}>{currentText}</Typography>}
      </Breadcrumbs>
    </Box>
  );
};

export default BreadcrumbsNav;
